<template>
  <div>
    <div class="textInput">
      <label class="label" for="tbox1">{{ Title }}</label>
      <span class="counter">{{ remaningLengthStyle }}/{{ maxStyle }}</span>
      <input
        class="input"
        :class="{ disable: disableStyle, errorStyle: errorMsgStyle }"
        type="text"
        id="tbox1"
        name="tbox1"
        :maxlength="maxStyle"
        :value="inputStyleName"
        @change="$emit('onChange', handleEmit($event.target))"
        required
        :disabled="disableStyle"
      /><br />
    </div>
  </div>
</template>

<script lang="ts">
export default {
  props: {
    Title: {
      type: String,
      default: ""
    },
    errorMsgStyle: {
      type: String,
      default: ""
    },
    remaningLengthStyle: {
      type: Number,
      default: 0
    },
    maxStyle: {
      type: Number,
      default: 30
    },
    disableStyle: {
      type: Boolean,
      default: false
    },
    inputStyleName: {
      type: String,
      default: ""
    }
  },
  emits: ["onChange"],
  methods: {
    handleEmit(target: EventTarget | null) {
      return (target as HTMLInputElement).value;
    }
  }
};
</script>

<style scoped>
.input {
  width: 260px;
  height: calc(1.4285714286em + 8px);
  border-color: rgba(0, 0, 0, 0.08);
  color: #424242;
  background-color: #ffffff;
  border-radius: 2px;
}
.label {
  font-size: 16px;
}
.counter {
  position: absolute;
  top: 41px;
  left: 242px;
  color: #767474;
  font-size: 12px;
}
.textInput {
  height: 57px;
}
.disable {
  background-color: #ccc;
  border-style: dashed;
}
.errorStyle {
  border-color: red;
}
</style>
